let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("arhgZ"), load("8qp7T")]).then(() => parcelRequire('by822'));